import { useMutation } from '@apollo/client';
import React, { useState } from 'react';
import AdminModal from '../../../../../components/AdminModal';
import useToast from '../../../../../customHooks/useToast';
import { ACTIVATE_AND_DEACTIVATE_STAFF } from '../../../../../graphql/admin_mutations';
import RoundMinusIcon from '../../../../../svgs/RoundMinusIcon';
import Styles from './DeactivateMember.module.scss';

interface IActivateRole{
  onClose:any;
  payload:any;
  refetch:any;
}
const DeactivateMember = ({ onClose, payload, refetch }:IActivateRole) => {
  const Toast = useToast();

  const [isSuccessful, setIsSuccessful] = useState(false);
  const [activate, { loading: activateLoading }] = useMutation<
  { modifyAdminStatus: any },
  any
>(ACTIVATE_AND_DEACTIVATE_STAFF);

  const activateAndDeactivateRole = async () => {
    const data = { adminId: payload?.id, status: 'inactive' };
    if (!activateLoading) {
      try {
        const res = await activate({
          variables: data,
        });

        if (res?.data?.modifyAdminStatus && res?.data?.modifyAdminStatus?.status === 200) {
          refetch?.();
          setIsSuccessful(true);
        } else {
          Toast.error(res?.data?.modifyAdminStatus?.message || 'Operation failed');
        }
      } catch (e) {
        if (e && e.graphQLErrors && e.graphQLErrors.length > 0) {
          Toast.error(e.graphQLErrors[0].message);
        } else {
          Toast.error('Something went wrong');
        }
      }
    }
  };
  return (
    <div className={Styles.wrapper}>
      <AdminModal
        headText={isSuccessful ? 'Member Deactivated!' : 'Are you sure you want to deactivate this member?'}
        subText={isSuccessful ? `${payload?.name} has been deactivated successfully.` : 'By clicking on “Deactivate”, the member and their assigned role will be deactivated. If you are not sure, please cancel.'}
        actionBtnName="Yes, deactivate"
        handleModalAction={activateAndDeactivateRole}
        topIcon={<div className={Styles.wrapper__icon}><RoundMinusIcon /></div>}
        isShow
        isActionBtnDisabled={activateLoading}
        isSuccess={isSuccessful}
        isTopIcon
        onClickAway={onClose}
        onClose={onClose}
        isLoading={activateLoading}
        hideLogo
        cancelBtnClass={Styles.wrapper__cancelBtn}
        actionBtnClass={isSuccessful ? Styles.wrapper__okayBtn : Styles.wrapper__deactivateBtn}
      />
    </div>
  );
};

export default DeactivateMember;
